import { ComponentProps, memo } from 'react';
import Lottie from 'react-lottie';
import { Card, Typography as Paragraph } from 'components';
import { isNowHoliday } from 'utils';
import AttentionLottie from 'assets/lottie/attention.json';
import H1 from 'components/H/H1';
import { Helmet } from 'react-helmet-async';
import HelpBlock from './HelpBlock';
import { useTranslation } from 'react-i18next';

const lottieOptions = {
  loop: false,
  autoplay: true,
  animationData: AttentionLottie,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
} satisfies ComponentProps<typeof Lottie>['options'];

export default memo(function DocumentUploadLater() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('document_upload_later:html_title')}</title>
      </Helmet>

      <Card className="max-w-[585px] lg:min-w-[380px] flex flex-col mx-auto py-16">
        <div
          className="mb-5 mx-auto w-[50px]"
          data-test="documentUploadLater-lottie-wrapper"
        >
          <Lottie options={lottieOptions} ariaRole="presentation" />
        </div>
        <H1 className="lg:text-center" dataTest="documentUploadLater-heading">
          {t('document_upload_later:heading')}
        </H1>
        <Paragraph
          className="mx-auto max-w-[442px] leading-[19px] text-center text-muted-dark"
          dataTest="documentUploadLater-subheading"
        >
          <span
            dangerouslySetInnerHTML={{
              __html: t('document_upload_later:send_later_text'),
            }}
            data-test="documentUploadLater-later-text"
          />
        </Paragraph>
      </Card>
      <div className="flex justify-center">
        <HelpBlock
          heading={t('document_upload_later:help_heading')}
          description={
            isNowHoliday()
              ? t('document_upload_later:help_info_holidays')
              : t('document_upload_later:help_info')
          }
        />
      </div>
    </>
  );
});
